const teamsCallPattern = (id, context = "%7b%22Tid%22%3a%22eaa6cb52-58d7-45cd-8bd6-b1d2a8e61312%22%2c%22Oid%22%3a%22bb6a15aa-306f-4327-856c-2e2e46c932db%22%7d") => 
    `https://teams.microsoft.com/l/meetup-join/19%3Ameeting_${id}%40thread.v2/0?context=${context}`

const availableCalls = {}
export const availableTimes = { haveAny: false }

Object.keys(window.dataLayer[0]).filter(x => x.match(/Table \d+: ([\w\s]+) \-.*/)).forEach(x => {
    availableCalls[/Table \d+: ([\w\s]+) \-.*/.exec(x)[1].trim()] = window.dataLayer[0][x] === "Yes"
})

const isAvailable = (columns, timeName = "one") => {
    return columns.map(({name, url}) => {
        availableTimes[timeName] = (availableCalls[name] || false) || (availableTimes[timeName] || false)
        availableTimes.haveAny = availableTimes.haveAny || availableTimes[timeName]
        return {
            name,
            url,
            available: availableCalls[name] || false
        }
    })
}

export const one = [
    [
        { name: "Julie Pacheco", url: teamsCallPattern("YmI4OGIyYjktMGQxMi00MWJhLWJjY2UtMDIyM2YxOWVkZGE0") },
        { name: "Stephan Dalkie", url: teamsCallPattern("YzNlOWI2MzItNDc5Ni00NDUyLWIzMzctYjZjMDgyYzVmMzAz") },
        { name: "Debby Doucette", url: teamsCallPattern("MDAzMjBmOGQtYTcwNS00NjdhLTlmMDQtMTZmZWYxYzE4OWZj") },
        { name: "Elaine Lukowski", url: teamsCallPattern("ZWMyNmExOTItMWI2Zi00Zjk2LTk5ZGMtNzgxZmFlYjEwNWVi") },
        { name: "Sabrina McManus", url: teamsCallPattern("M2M2MDQ4ZjItN2YyMi00MTUxLWE1NDItZjMzOTM5OGNjMjFh") },
    ],
    [
        { name: "Samara Foisy", url: teamsCallPattern("NTQzZDE3MGYtNTU2ZS00MDE3LWFhNzEtZmNiOWFmMjg1YjVj") },
        { name: "Janet Rickford", url: teamsCallPattern("YjYxMmUyYjctZGRjYS00Mzg1LWE3YmMtYzljY2U3ODQxMjVk") },
        { name: "Mubashir Jamal", url: teamsCallPattern("Y2ZmOGUzMzgtMGNjNi00ZWJiLWFmMzYtM2NmNTBhZWJiNGVl") },
        { name: "Irene Doody", url: teamsCallPattern("Mzc4NGU0NjctNjQ1MS00MzZjLTgyMjgtYjViZGQ1ZmFiOWQz") },
        { name: "Hailey Kwok", url: teamsCallPattern("YjgwYWZjOTAtMDE4NS00MWUyLWEwZGYtYmZlZmI5Y2Q1NzMw") },
    ],
    [
        { name: "Rosa Fowler", url: teamsCallPattern("NzY2MTQxMGItZmQxMi00YjQwLTgyMTUtZWU1ZmJkYmFhODc2") },
        { name: "Rohit Sriram", url: teamsCallPattern("YmVmZDQ2ZmQtNTc4ZC00NTcxLWJjMjAtM2QzMzY1NTAzOGZi") },
        { name: "Fauve Ross", url: teamsCallPattern("ZWVmNDI3ODctOTk1Mi00ZTc3LThjZGEtZDQxOTUxMDNkMDhk") },
        { name: "Fausto Lopes", url: teamsCallPattern("NDAxYWI0NjgtMmIyOC00ZTY3LWFiMWItMTc0OTZlYzMyNDAw") },
        { name: "Mike Harvey", url: teamsCallPattern("NTQ2OTMzYzItN2EwZC00ZTVhLWI2YzQtODNkZTRhYWY2ZWI1") },
    ],
    [
        { name: "Joe Difalco", url: teamsCallPattern("ZWIyOGNmZDEtOWVhNS00YTVkLTkwZjctYTliZDg0YzliNTNh") },
        { name: "Greg Ramier", url: teamsCallPattern("MzJiOGFmMzMtMmU2Yi00YWFlLWJhN2QtN2VmYmVhZTRiM2Vm") },
        { name: "Mark Wilson", url: teamsCallPattern("NmU1MDJmMGYtYzgyYy00OTcyLTgwNDEtN2RiYzY1MWRkMDRi") },
        { name: "Richard Dufresne", url: teamsCallPattern("YjU0YTYwYzMtODc3MS00YzM1LThkYjgtYzA2ZDBiODEyOTky") }
    ]
].map(row => isAvailable(row, "one"))

export const two = [
    [
        { name: "Katie Tingley", url: teamsCallPattern("Yzg0ODYyN2MtYTYyOC00NDVlLTlkYWMtMzEwNzE4NzhlYmMw") },
        { name: "Babie Nagra", url: teamsCallPattern("ODk5NzdjNjUtMzkzNS00ZmE0LWJlOGItYmQ5NWEyMmNkYjg3") },
        { name: "Kelly Palmer", url: teamsCallPattern("MDRjYTJhMTktYTBlNy00MzBjLThiZmEtZmJjYzA0ZDExNjky") },
        { name: "Wendy Hui", url: teamsCallPattern("YWRiNjZhNjAtZjQ4Yi00N2ZkLTk4YTctNTUzYmEzYTZlZDNi") },
        { name: "Hardeep Kharaud", url: teamsCallPattern("YTAyYmFmNmYtZDQwOC00MWYwLTkzNTAtYTNiNDIzNzI4MzMy") },
    ],
    [
        { name: "Kathlyne Ross", url: teamsCallPattern("YWEwMTcyZTQtM2VhZC00M2U4LTllYjQtMjJmM2VhYzU2MjY3") },
        { name: "Melissa Da Silva", url: teamsCallPattern("MjkwNGNhZTEtZDI1Ny00ZTc5LWJkN2ItNWQ1OTExNzVkZTMz") },
        { name: "Sharla Paraskevopoulos", url: teamsCallPattern("NTM1NDI2M2UtZDBmOC00MjQ4LWE5ZmYtMDViN2ViYTZlYmVi") },
        { name: "Thomas Hey", url: teamsCallPattern("ZDNhM2VlOGItMjg1Ny00MmEyLTk0N2EtYzMyZTE0ZDJkNTUz") },
        { name: "Dave Puri", url: teamsCallPattern("Njk5NjEwZjUtMTAyMi00YzJhLWE1MDgtOTcwMmZmZmI2Nzk4") },
    ],
    [
        { name: "Vivek Khindria", url: teamsCallPattern("NWQ5ODFmZWEtODBmOC00ZjdiLWIwY2MtODVlZDNiMTlkMWI4") },
        { name: "Akeel Abdeen", url: teamsCallPattern("NjI2MTMxNzctNGNhZC00OTkxLTk0NGYtNWYzNTM2NGEwNTg3") },
        { name: "Rob Wiebe", url: teamsCallPattern("ZDdiOGZhMGUtYmQ5OS00ODU2LTg1NDktMTgzMjlhZjc4Njc2") },
        { name: "Allison Jorgens", url: teamsCallPattern("YWRlYWMxZjQtMDI1NS00ZDM1LWFhZTctZjIwYWQ3NDQ0ZGEw") },
        { name: "Ian Freedman", url: teamsCallPattern("NWYxOTZhNTgtODUyNC00MTRlLWE2YWEtOTExODhjMGIxYzI0") },
    ],
    [
        { name: "Jennifer Boyce", url: teamsCallPattern("N2YyN2MzOGItZDYyOS00ZTk1LWI4ODQtODgyZjk4ODJlZjA4") }
    ]
].map(row => isAvailable(row, "two"))

export const three = [
    [
        { name: "Lindsay Cook", url: teamsCallPattern("NDg5ZmQ5Y2YtN2RlZS00YWYwLTkyNzYtNWJhYjQyMDhiNDg1") },
        { name: "Myles Parlee", url: teamsCallPattern("ZmI3NmJiNzYtMzBlYy00MTcwLThkZWEtYjVlM2MxMWFmMTA1") },
        { name: "Benoit Jones", url: teamsCallPattern("ZDRjNTA1ZDktZTlkYi00MmJhLWEyYjUtZmVmZWVmYWQ3MmRi") },
        { name: "Lisa Pinto", url: teamsCallPattern("ZmZjNmM0YTgtNDU0ZC00NjhkLWFmNGItMjg5MWExMWM3ZTcw") },
        { name: "Sunny Dhillon", url: teamsCallPattern("N2JhNjBjNDktMmNjOC00MTA1LTk4YTYtZWRkMmZmMTJiODEw") },
    ],
    [
        { name: "Vanessa Mai", url: teamsCallPattern("NmU0NzdlNzUtNWVjYS00Mjg4LWJkZmEtMTA0ZGRjOThkYTcx") },
        { name: "Mike Doucette", url: teamsCallPattern("M2Q5Yjk1NDUtZGZiMC00MzViLWIwYWUtMmU1N2YzYWJhNjQw") },
        { name: "Jennifer Casu", url: teamsCallPattern("Y2QyNmExMjEtMzczYy00ZGQ0LWIzOGUtNmZkM2UxYjczODUz") },
        { name: "Nicolas Diard", url: teamsCallPattern("MzRmODI0NmQtZTRkNi00ZTVmLTkxMDItMjAyMDJmMzA0MTRh") },
        { name: "Rahim Ismail", url: teamsCallPattern("MTU5MzYwNTQtNzk5Ny00NmVlLWFhNTUtYTE0ZDMzNDdiNGEw") },
    ],
    [
        { name: "Sharyon De Souza", url: teamsCallPattern("ZDViNDVhYTQtOTc3MC00Njk4LThiMDktYzBiOThkZjhhYTlk") },
        { name: "Nelm Khangura", url: teamsCallPattern("YWE3ZWIwZmQtNGJkOS00OTlmLWIxNDAtMzliM2I2MmZiZTVi") },
        { name: "Millia Wong", url: teamsCallPattern("MTAxMDljYWItNmI3MS00YjQ2LWE1MjgtMWY4ZmIzMDhmN2E1") },
        { name: "Vlad Rebellon", url: teamsCallPattern("Nzc3ZTU2MmUtZTEzZC00NzM1LTk2ZGYtNzNhMWY5Nzg1Y2Y0") },
        { name: "Heather Fadali", url: teamsCallPattern("MWFlMDBlNjYtMWMyNS00NmM1LTkyNjgtOGIzMmMwNTFjNDA3") },
    ]
].map(row => isAvailable(row, "three"))